import React from 'react';
import TaskBar from './TaskBar';
import AdminMenu from '../Admin/AdminMenu';
import { combineThemeClasses } from '../../utils/theme';
import { Compass } from 'lucide-react';

const MenuBar = ({
  setShowGallery,
  activeApps,
  windowStates,
  focusedWindowId,
  toggleMinimize,
  bringWindowToFront,
  snapViewportToApp,
  selectedAppIds,
  setSelectedAppIds,
  applyLayoutToSelectedApps,
  closeWindow,
  toggleNavigator,
  navigatorButtonRef,
  theme = 'dark',
  launchSDK
}) => {
  return (
    <div className={combineThemeClasses(theme, ['menuBar.base'])}>
      <div className={combineThemeClasses(theme, ['menuBar.section.left'])}>
        <button
          ref={navigatorButtonRef}
          onClick={() => toggleNavigator()}
          className={combineThemeClasses(theme, ['menuBar.button.base', 'menuBar.button.hover'])}
          title="Toggle Navigator"
        >
          <Compass size={16} />
        </button>

        <button
          onClick={() => setShowGallery(true)}
          className={combineThemeClasses(theme, ['menuBar.button.base', 'menuBar.button.hover'])}
        >
          Applications
        </button>
      </div>

      <div className={combineThemeClasses(theme, ['menuBar.section.center'])}>
        <TaskBar
          activeApps={activeApps}
          windowStates={windowStates}
          focusedWindowId={focusedWindowId}
          toggleMinimize={toggleMinimize}
          bringWindowToFront={bringWindowToFront}
          snapViewportToApp={snapViewportToApp}
          selectedAppIds={selectedAppIds}
          setSelectedAppIds={setSelectedAppIds}
          applyLayoutToSelectedApps={applyLayoutToSelectedApps}
          closeWindow={closeWindow}
          theme={theme}
        />
      </div>

      <div className={combineThemeClasses(theme, ['menuBar.section.right'])}>
        <AdminMenu theme={theme} onLaunchSDK={launchSDK} />
      </div>
    </div>
  );
};

export default MenuBar;
